export default function Input({ label, error, className = '', ...rest }) {
  return (
    <div className="w-full">
      {label && <label className="label">{label}</label>}
      <input className={`input-base ${error ? 'border-red-500' : ''} ${className}`} {...rest} />
      {error && <p className="mt-1 text-xs text-red-400">{error}</p>}
    </div>
  );
}
